// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3fef1c06] .ag-input-field-form-checkbox-group{color:#404040 !important;text-decoration:none !important;border:none;width:100%;height:100%;background-color:#fff;padding:10px;border-radius:5px}", ""]);
// Exports
module.exports = exports;
